import * as React from 'react';

export default function ResearchNav(props: any) { 
    return (
        <div className="research-nav">
            <ul>
                <li className={ props.index === 0 ? 'current' : '' }>
                    <a href="/mobile/uc/build/research">
                        <div className="fonts">行业报告</div>
                    </a>
                </li>
                <li className={ props.index === 1 ? 'current' : '' }>
                    <a href="/mobile/uc/build/research/analysis">
                        <div className="fonts">决策解析</div>
                    </a>
                </li>
                <li className={ props.index === 2 ? 'current' : '' }>
                    <a href="/mobile/uc/build/research/service">
                        <div className="fonts">指数服务</div>
                    </a>
                </li>
                <li className={ props.index === 3 ? 'current' : '' }>
                    <a href="/mobile/uc/build/research/center">
                        <div className="fonts">价格中心</div>
                    </a>
                </li>
            </ul>
        </div>
    )
}